import React, {useState, useEffect} from 'react';
import {BrowserRouter as Router, Switch, Route, Redirect} from 'react-router-dom';

import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';

import Menu from './components/menu/menu';

import Page from './pages/page';
import Editorial from './pages/editorial';
import Home from './pages/home';
import Ajustes from './pages/ajustes';
import Consulta from './pages/consulta';
import Errores from './pages/errores';
import Login from './pages/login';
import P404 from './pages/P404';
import PERROR from './pages/PERROR';
import Alerta from './components/alerta';

import {useSnackbar} from 'notistack';

import {useNetwork} from 'react-use';

import {useSelector, useDispatch} from 'react-redux';
import {iniciarSesion} from 'actions/usuarioActions';
import {ocultarAlerta, mostrarAlerta} from 'actions/alertaActions';
import {initPush} from 'actions/notificacionesActions';
import {mostrarSnack} from 'actions/snackActions';

import {localVar} from 'components/constants';

export default function App() {
    const alerta = useSelector((state) => state.alerta.alerta);
    const snackMsg = useSelector((state) => state.snack.snackmsg);
    const usuario = useSelector((state) => state.usuario.usuario);
    const token = useSelector((state) => state.usuario.token);
    const loading = useSelector((state) => state.usuario.loading);
    const errorUsuario = useSelector((state) => state.usuario.error);

    const dispatch = useDispatch();

    const {enqueueSnackbar} = useSnackbar();

    const [configMenu, setconfigMenu] = useState(false);
    const [openMenu, setOpenMenu] = useState(false);

    const toggleDrawer = (open) => (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setOpenMenu(open);
        setconfigMenu(true);
    };

    const [ubodesconexion, setUbodesconexion] = useState(false);

    const network = useNetwork();
    useEffect(() => {
        if (Object.keys(network).length === 0) return;
        if (!network.online) {
            console.log(network);
            dispatch(
                mostrarSnack('Oh! Se ha perdido la conexión! 😱', {
                    variant: 'warning',
                    anchorOrigin: {vertical: 'top', horizontal: 'center'},
                })
            );
            setUbodesconexion(true);
        } else if (ubodesconexion) {
            dispatch(
                mostrarSnack('Se ha restablecido la conexión🙂', {
                    variant: 'success',
                    anchorOrigin: {vertical: 'top', horizontal: 'center'},
                })
            );
            setUbodesconexion(false);
        }
    }, [network, enqueueSnackbar, ubodesconexion, dispatch]);

    useEffect(() => {
        if (errorUsuario) {
            dispatch(mostrarAlerta(errorUsuario));
        }
    }, [errorUsuario, dispatch]);

    useEffect(() => {
        if (snackMsg) {
            if (snackMsg.txt) {
                enqueueSnackbar(snackMsg.txt, snackMsg.rest);
            } else {
                enqueueSnackbar(snackMsg);
            }
        }
    }, [snackMsg, enqueueSnackbar]);

    useEffect(() => {
        console.log(usuario);
        if (usuario && usuario.dni) {
            console.log('initPush', usuario.dni);
            dispatch(initPush(usuario.dni));
        }
    }, [usuario, dispatch]);

    useEffect(() => {
        if (!token && !loading && !localVar.getItem('token')) {
            iesAuth.signout();
            // window.location.replace('/');
        }
    }, [token, loading]);

    useEffect(() => {
        if (localVar.getItem('token')) {
            dispatch(iniciarSesion({}));
        }
    }, [dispatch]);

    return (
        <Router basename="/">
            <>
                <Alerta dialogProps={alerta} setDialogProps={() => dispatch(ocultarAlerta())} />

                {usuario && (
                    <SwipeableDrawer
                        disableSwipeToOpen={false}
                        open={openMenu}
                        onClose={toggleDrawer(false)}
                        onOpen={toggleDrawer(true)}
                    >
                        <Menu open={configMenu} setOpenMenu={setOpenMenu} />
                    </SwipeableDrawer>
                )}

                <Switch>
                    <PrivateRoute exact path="/tid/:TID/errores">
                        <Errores openMenu={openMenu} setOpenMenu={setOpenMenu} />
                    </PrivateRoute>
                    <PrivateRoute exact path="/tid/:TID/consulta">
                        <Consulta openMenu={openMenu} setOpenMenu={setOpenMenu} />
                    </PrivateRoute>
                    <PrivateRoute exact path="/tid/:TID/editorial">
                        <Editorial openMenu={openMenu} setOpenMenu={setOpenMenu} />
                    </PrivateRoute>
                    <PrivateRoute exact path="/tid/:TID/page/:idn">
                        <Page openMenu={openMenu} setOpenMenu={setOpenMenu} />
                    </PrivateRoute>
                    <PrivateRoute exact path="/tid/:TID">
                        <Page openMenu={openMenu} setOpenMenu={setOpenMenu} />
                    </PrivateRoute>
                    <PrivateRoute exact path="/ajustes">
                        <Ajustes openMenu={openMenu} setOpenMenu={setOpenMenu} />
                    </PrivateRoute>
                    <PrivateRoute exact path="/">
                        <Home openMenu={openMenu} setOpenMenu={setOpenMenu} />
                    </PrivateRoute>
                    <Route exact path="/perror/:origen">
                        <PERROR />
                    </Route>
                    <Route exact path="/login">
                        <Login iesAuth={iesAuth} />
                    </Route>
                    <Route path="*">
                        <P404 iesAuth={iesAuth} />
                    </Route>
                </Switch>
            </>
        </Router>
    );
}

const iesAuth = {
    isAuthenticated: localVar.getItem('token') ? true : false,
    authenticate(cb) {
        iesAuth.isAuthenticated = true;
        setTimeout(cb, 100);
    },
    signout(cb) {
        iesAuth.isAuthenticated = false;
        setTimeout(cb, 100);
    },
};

function PrivateRoute({children, ...props}) {
    return (
        <Route
            {...props}
            render={({location}) =>
                iesAuth.isAuthenticated ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: {from: location},
                        }}
                    />
                )
            }
        />
    );
}
